import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { CalendarOff } from "lucide-react";

const TIPI = { ferie: "Ferie", permesso: "Permesso", malattia: "Malattia" };

export function AssenzeForm({ dipendentiIds, giorni }) {
  const qc = useQueryClient();
  const [tipo, setTipo] = useState("ferie");
  const [ore, setOre] = useState("8");
  const mut = useMutation({
    mutationFn: async () => (await api.post("/assenze/bulk", { dipendenti_ids: dipendentiIds, giorni, tipo, ore: Number(ore) })).data,
    onSuccess: (r) => {
      toast.success(`${r.inserite} registrazioni di ${TIPI[tipo].toLowerCase()} salvate`);
      qc.invalidateQueries({ queryKey: ["controllo-giornaliero"] });
      qc.invalidateQueries({ queryKey: ["stato-giorno"] });
    },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
  const submit = () => {
    if (dipendentiIds.length === 0) return toast.error("Seleziona almeno un dipendente");
    if (!(Number(ore) > 0 && Number(ore) <= 8)) return toast.error("Le ore devono essere comprese tra 0 e 8");
    mut.mutate();
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5" data-testid="assenze-form">
      <h2 className="font-display text-lg font-semibold text-slate-800 flex items-center gap-2 mb-3">
        <CalendarOff className="h-5 w-5 text-sky-600" /> Ferie / Permesso / Malattia
      </h2>
      <p className="text-xs text-slate-500 mb-3">Usa i dipendenti e i giorni selezionati qui sopra. Le ore contano per il controllo delle 8 ore giornaliere ma non entrano nei costi delle commesse.</p>
      <div className="flex flex-wrap items-end gap-3">
        <div className="space-y-1.5">
          <Label>Tipo</Label>
          <Select value={tipo} onValueChange={setTipo}>
            <SelectTrigger className="w-[160px]" data-testid="assenza-tipo"><SelectValue /></SelectTrigger>
            <SelectContent>{Object.entries(TIPI).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>Ore</Label>
          <Input type="number" min="0.5" max="8" step="0.5" value={ore} onChange={(e) => setOre(e.target.value)} className="w-24 text-right" data-testid="assenza-ore" />
        </div>
        <Button variant="outline" onClick={submit} disabled={mut.isPending} data-testid="assenza-submit">
          Salva {TIPI[tipo].toLowerCase()} ({giorni.length} {giorni.length === 1 ? "giorno" : "giorni"})
        </Button>
      </div>
    </div>
  );
}
